module.exports = __webpack_public_path__ + "static/media/VIP_5.d83676c8.jpg";